export enum ServiceType {
  /** 试用 */
  experience = 1,
  /** 订阅 */
  subscribe = 2,
}
